import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ZigButton, ZigTypography, ZModal } from '@ui/index';
import { useUserAcceptTosMutation } from '../../../../apis/user/api';
import { ZModalProps } from '../../../../components/ZModal/types';
import AnchorLink from '../../../../components/AnchorLink';
import { ROUTE_LEGAL_TOS } from '../../../../routes';

const TosVerifyModal = ({
  onSuccess,
  onFailure,
  ...props
}: ZModalProps & { onSuccess: () => void; onFailure: () => void }) => {
  const { t } = useTranslation(['error']);
  const [acceptTos, { isLoading: isAcceptingTos }] = useUserAcceptTosMutation();

  return (
    <ZModal
      {...props}
      wide
      title={t('tos-modal.title')}
      close={undefined}
      mobileFullScreen
    >
      <ZigTypography align={'center'}>
        <Trans t={t} i18nKey={'tos-modal.description'}>
          <AnchorLink to={ROUTE_LEGAL_TOS} target={'_blank'} />
        </Trans>
      </ZigTypography>

      <ZigButton
        variant={'contained'}
        size={'xlarge'}
        loading={isAcceptingTos}
        onClick={async () => {
          await acceptTos().unwrap();
          props?.close();
          onSuccess?.();
        }}
      >
        {t('tos-modal.cta')}
      </ZigButton>

      <ZigButton
        sx={{ mt: 2 }}
        variant={'text'}
        disabled={isAcceptingTos}
        onClick={async () => {
          props?.close();
          onFailure?.();
        }}
      >
        {t('common:account-menu.notAuth-button-logOut')}
      </ZigButton>
    </ZModal>
  );
};

export default TosVerifyModal;
